import React from "react";
import { Modal, Button } from "react-bootstrap";
import errorIcon from "../../assets/errorIcon.svg";
//import "./coupon.scss"
const NoPateintSelected = (props) => {
  const { show, handleClose, type, handleYes, handleErrorClose } = props;
  return (
    <Modal
      show={show}
      onHide={type === "nopatientselected" ? handleClose : handleYes}
      backdrop="static"
      centered
      style={{ zIndex: "3000" }}
    >
      <button
        className=" mr-2 align-baseline text-right close-button "
        onClick={type === "nopatientselected" ? handleClose : handleYes}
        style={{ backgroundColor: "white" }}
      >
        Close<span style={{ fontSize: "22px" }}>x</span>{" "}
      </button>

      <Modal.Body className="modaldesc my-4 ">
        <div className="text-center">
          <img
            alt="Error"
            style={{ width: "70px", height: "70px" }}
            src={errorIcon}
          />
          {type === "nopatientselected" ? (
            <p className="font-weight-bold mt-3" style={{ fontSize: "18px" }}>
              Please select one or more patient(s)
            </p>
          ) : (
            <p className="font-weight-bold mt-3" style={{ fontSize: "18px" }}>
              Are you sure you want to leave this page?
              <br />
              <span style={{ fontSize: "15px" }}>
                Leaving this page will lose your changes
              </span>
            </p>
          )}
        </div>
        {type === "nopatientselected" ? (
          <div className="text-center">
            <button
              className="btn-lg rounded-pill mt-3"
              style={{
                backgroundColor: "#17BAE0",
                color: "#fff",
                width: "7rem",
                marginBottom: "2rem",
              }}
              onClick={handleClose}
            >
              Ok
            </button>
          </div>
        ) : (
          <div className="container my-4 px-5">
            <div className="row justify-content-center px-3 ">
              <div className="col order-sm-12 mb-sm-2 ">
                <Button
                  className="btn btn-lg border-0 mb-md-2  border rounded-pill coupon-confirm-button"
                  style={{ backgroundColor: "#17BAE0", color: "#fff" }}
                  onClick={handleYes}
                >
                  Yes
                </Button>
              </div>

              <div className="col order-sm-1 ">
                <Button
                  className="btn btn-lg border   rounded-pill coupon-confirm-button"
                  style={{ backgroundColor: "#fff", color: "#17BAE0" }}
                  onClick={handleErrorClose}
                >
                  No
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NoPateintSelected;
